import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import FormattedTime from '@components/FormattedTime'
import { getReadableTextColor } from '@helpers/color_scheme_helpers.js'
import { getPixelDataURL } from '../../../utils/canvas'
import { ThemeContext } from '../../../base/ThemeContext'
import { sanitize, markupAndSanitize } from '@utils/sanitize'

export default class Timespan extends PureComponent {
  getHeaderContent() {
    const { data } = this.props
    const colorScheme = this.context
    const backgroundColor = colorScheme.highlight
    const textColor = getReadableTextColor(backgroundColor, colorScheme)
    const style = { backgroundColor, color: textColor }
    const titleStyle = { color: textColor }
    return (
      <div className="timeline-item__header" style={style}>
        <div className="timeline-item__date">
          Period: <FormattedTime dateTime={data.start_date} /> to <FormattedTime dateTime={data.end_date} />
        </div>
        <h2
          className="timeline-item__title"
          style={titleStyle}
          dangerouslySetInnerHTML={{ __html: sanitize(data.title) }}
        ></h2>
      </div>
    )
  }

  getDescriptionContent() {
    const { data } = this.props
    const colorScheme = this.context
    const backgroundColor = colorScheme.secondary
    const style = { backgroundColor, color: getReadableTextColor(backgroundColor, colorScheme) }
    const description = data.description
    if (description !== '') {
      return (
        <div
          className="timeline-item__body"
          style={style}
          dangerouslySetInnerHTML={{ __html: markupAndSanitize(description) }}
        ></div>
      )
    }
    return null
  }

  render() {
    const colorScheme = this.context
    const description = this.getDescriptionContent()
    const header = this.getHeaderContent()

    const itemStyle = { backgroundImage: `url(${getPixelDataURL(colorScheme.tertiary)})` } // main timeline line in vertical mode (narrow screens)
    const lineStyle = { backgroundColor: colorScheme.tertiary } // connector line to main timeline line in side by side mode (wide screens)
    const dotStyle = { backgroundColor: colorScheme.highlight }

    return (
      <li className="list-timeline__item timeline-item timeline-item--viewer" style={itemStyle}>
        <div className="timeline-item__line" style={lineStyle}></div>
        <div className="timeline-item__dot">
          <div className="dot__graphic" style={dotStyle}></div>
        </div>
        <div className="timeline-item__content-wrapper">
          <div className="timeline-item__content">
            {header}
            {description}
          </div>
        </div>
      </li>
    )
  }
}

Timespan.contextType = ThemeContext

Timespan.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
  }).isRequired,
}
Timespan.defaultProps = {}
